import { Redirect } from "react-router"
import { myLazy } from "utils/myLazy"
import { GooglePageViewTypes } from "utils/googleAnalytics/googleAnalyticsPageViewEvent"

export const adminProductRoutes = [
  {
    exact: true,
    path: "/admin/product/b2b/list",
    component: myLazy(() => import("views/admin/product/productList")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Lista de produse - Uniprest Instal Digital"
  },
  {
    exact: false,
    path: "/admin/product/b2b/form",
    component: myLazy(() => import("views/admin/product/productForm/productForm")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Produse"
  },
  {
    exact: false,
    path: "/admin/product/b2brelations/list",
    component: myLazy(() =>
      import("views/admin/product/relationList/relationList")
    ), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Relații între produse - Uniprest Instal Digital"
  },
  {
    exact: true,
    path: "/admin/product/compano/list",
    component: myLazy(() => import("views/admin/product/companoList")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Lista de produse - Compano"
  },
  {
    exact: false,
    path: "/admin/product/compano/form",
    component: myLazy(() =>
      import("views/admin/product/productCompanoForm/productCompanoForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Produse"
  },

  //===================================================================
  //4.3
  {
    exact: true,
    path: "/admin/product/discount/list",
    component: myLazy(() => import("views/admin/product/grilaDiscounts/List")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Grile de discount"
  },
  {
    exact: false,
    path: "/admin/product/discount/form",
    component: myLazy(() =>
      import("views/admin/product/grilaDiscounts/GrilaForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Grile de discount"
  },
  //===================================================================
  //4.4 - Preturi nete nete
  {
    exact: true,
    path: "/admin/product/net/list",
    component: myLazy(() => import("views/admin/product/price/List")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Prețuri net net"
  },

  {
    exact: false,
    path: "/admin/product/net/form",
    component: myLazy(() => import("views/admin/product/productNetForm")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Prețuri net net"
  },

  // 4.5 Volume
  {
    exact: true,
    path: "/admin/product/volume/list",
    component: myLazy(() =>
      import("views/admin/product/volumeDiscount/volumeDiscountList")
    ), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Discounturi volum"
  },
  {
    exact: false,
    path: "/admin/product/volume/form",
    component: myLazy(() =>
      import("views/admin/product/volumeDiscount/productVolumeForm")
    ), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Discounturi volum"
  },

  //===================================================================
  //4.6 Pachete
  {
    exact: true,
    path: "/admin/product/pack/list",
    component: myLazy(() => import("views/admin/product/pack/packTable")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Pachete"
  },
  //   {
  //     exact: true,
  //     path: "/admin/product/pack/form/add",
  //     component: myLazy(() => import("views/dev/norbert/wizzards/AdaugaPachet/wizzardForm.jsx")),
  //   },
  {
    exact: false,
    path: "/admin/product/pack/form",
    component: myLazy(() => import("views/admin/product/pack/packForm")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Pachete"
  },

  // 4.7 Matricea de produse
  {
    exact: true,
    path: "/admin/product/matrix/list",
    component: myLazy(() => import("views/admin/product/productMatrix")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Matrice de produs"
  },

  //===================================================================
  //4.8 Badges
  {
    exact: true,
    path: "/admin/product/badge/list",
    component: myLazy(() => import("views/admin/product/badge/badgeList")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Badge-uri"
  },
  {
    exact: false,
    path: "/admin/product/badge/form",
    component: myLazy(() =>
      import("views/admin/product/badge/badgeForm/badgeForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Badge-uri"
  },
  // { //moved to modal
  //     exact: true,
  //     path: "/admin/product/badge/form/add",
  //     component: myLazy(() => import("views/admin/product/badge/addBadgeWizzard/addBadgeWizzard")),
  // },

  //===================================================================
  //4.9 QA

  {
    exact: true,
    path: "/admin/product/qa/list",
    component: myLazy(() =>
      import("views/admin/intrebariSiRaspunsuri/intrebariSiRaspunsuri")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Întrebări și răspunsuri"
  },
  {
    exact: false,
    path: "/admin/product/qa/form",
    component: myLazy(() =>
      import("views/admin/product/customer/qa/questionsAnswersForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Întrebări și răspunsuri"
  },

  //===================================================================
  //4.10 Reviews
  {
    exact: true,
    path: "/admin/product/review/list",
    component: myLazy(() => import("views/admin/recenzii/recenzii")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Recenzii"
  },
  {
    exact: false,
    path: "/admin/product/review/form",
    component: myLazy(() => import("../views/admin/recenzii/form/RecenziiForm")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Recenzii"
  },

  //===================================================================
  //4.11 Doc Techince
  {
    exact: true,
    path: "/admin/product/document/list",
    component: myLazy(() => import("views/admin/documents/documentsList")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Documente tehnice"
  },
  {
    exact: false,
    path: "/admin/product/document/form",
    component: myLazy(() => import("views/admin/documents/documentsForm")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Documente tehnice"
  },
  //==============================================================
  // Warehouse
  {
    exact: true,
    path: "/admin/product/warehouse/list",
    component: myLazy(() =>
      import("../views/admin/depoziteUniprest/depoziteUniprest")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Listă depozite"
  },
  {
    exact: false,
    path: "/admin/product/warehouse/details",
    component: myLazy(() => import("../views/admin/product/warehouseDetails")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Listă depozite"
  },
  //==============================================================================
  //4.14 Interes produse fara pret
  {
    exact: true,
    path: "/admin/product/pricerequest/list",
    component: myLazy(() => import("views/admin/product/priceRequest/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Interes produse fără preț"
  },
  {
    exact: true,
    path: "/admin/product/pricerequest/form",
    component: myLazy(() =>
      import("views/admin/product/priceRequest/priceRequestForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Interes produse fără preț"
  },
  //===================================================================
  //4.13 Interes produse fara stoc
  {
    exact: true,
    path: "/admin/product/stockrequest/list",
    component: myLazy(() => import("views/admin/product/stockRequest/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Interes produse fără stoc"
  },
  {
    exact: true,
    path: "/admin/product/stockrequest/form",
    component: myLazy(() =>
      import("views/admin/product/stockRequest/stockRequestForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Interes produse fără stoc"
  },
  //===================================================================
  {
    exact: true,
    path: "/admin/product/dashboard",
    component: myLazy(() => import("views/admin/unifiedDashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  },
  {
    exact: false,
    path: "/admin/product",
    component: () => <Redirect to="/admin/product/dashboard" />,
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  }
]
